export default "__VITE_ASSET__j96vnDxU__"